import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public sqlRequests: Array<number> = [];
  public serverTime: number;
  public deltaServer: number; // Time diff between the server and the user's pc
  public realTime: number;
  public clock: string; // Clock displayed on dashboard
  public constructor(private http: HttpClient) {}

  public CallGet(
    api: string,
    args: Object,
    json?: boolean,
    version = environment.apiVersion
  ): Observable<{}> {
    return this.http.get(this.GenerateUrl(api, version, args, json));
    // .map((res: Response) => res.json());
  }

  public CallPost(
    api: string,
    args: Object,
    data: FormData | string,
    version = environment.apiVersion
  ): Observable<{}> {
    return this.http.post(this.GenerateUrl(api, version, args), data);
    // .map((res: Response) => res.json());
  }

  private GenerateUrl(api: string, version: number | any, args: Object, json?: boolean): string {
    let url: string = environment.apiBaseUrl;
    url += version + '/' + api;

    let argsArray: Array<string> = Object.keys(args);
    if (argsArray.length > 0) {
      url += '?';
    }
    for (let arg in args) {
      url += arg + '=';
      url += json ? args[arg] : encodeURIComponent(args[arg]);
      if (argsArray.indexOf(arg) < argsArray.length - 1) {
        url += '&';
      }
    }
    // if (isDevMode()) {
    //   url += '&debug';
    // }
    console.debug('success API ', url);
    return url;
  }
}
